<template>
<div class="col essential-reading"> 
    <h3 class="section-heading">Essential Reading</h3>
    <ul v-if="is_state_solutions" class="items essential-reading-items">
        <template v-for="(post, rindex) in section.posts" >
            <li class="item" :key="post.id" v-if="(rindex+1) <= section.item_limit">
                <div class="excerpt" v-html="handle_excerpt_links(post.excerpt,post.url,post.title)"></div>
                <div v-if="post.type == 'charticle' || post.type == 'summary'">
                    <div class="link"><a :href="post.url + '#summary'" :target="hrefTarget">Summary</a></div>
                    <div class="link" v-if="post.has_charticle == 1"><a :href="post.url + '#charticle'" :target="hrefTarget">Charticle</a></div>
                </div>
            </li>
        </template>
    </ul>
    <ul v-else class="items">
        <template v-for="(post, rindex) in section.posts" >
            <li class="item" :key="post.id" v-if="(rindex+1) <= section.item_limit"> 
                <div class="item-title"><a :href="post.url" :target="hrefTarget"> {{post.title}} </a></div> 
                <div class="item-author" :class="{'block': (issue.parent_issue_id == null)}" > {{post.byline}} </div>
                <div class="excerpt" v-html="post.excerpt"></div> 
                <div v-if="post.type == 'charticle' || post.type == 'summary'">
                    <div class="link"><a :href="post.url + '#summary'" :target="hrefTarget">Summary</a></div> 
                    <div class="link" v-if="post.has_charticle == 1"><a :href="post.url + '#charticle'" :target="hrefTarget">Charticle</a></div>
                </div>
            </li>
        </template>
    </ul>
    <div v-if="section.item_limit < section.posts.length" 
        class="load-more" @click="displayMorePostsForSection(section)">Load More</div>
</div><!--End of essential reading-->
</template>

<script>

import SectionsMixin from './SectionsMixin.js';

export default {
    name: 'essential-reading',
    mixins: [
        SectionsMixin,
    ],
    data: function () {
        return {
            is_state_solutions: false,
        }
    },
    mounted: function(){
        this.check_if_state_solutions();
    },
    methods:{
       check_if_state_solutions(){
          if(document.URL.indexOf('state_solutions') > -1) {
            this.is_state_solutions = true;
          }else {
              this.is_state_solutions = false;  
          }
       } ,
        handle_excerpt_links(excerpt,url,title){
           
           if(excerpt == null || excerpt == ""){
               
               if(url == null || url == "") {
                   return title;
               }else {
                   return '<a href="' + url + '">' + title + '</a>';
               }
               
           }else if(excerpt.indexOf('</a>') > -1 ){
               return excerpt;
           }else if(url != null){
               return '<a href="'+url+'">'+excerpt+'</a>';
           }else {
               return excerpt;
           }
        }
    }
}
</script>